import { inject } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { MemberStore } from "../../store/member/member.store";
import { of } from "rxjs";

export const getMemberResolver: ResolveFn<any> = (route) => {
    const memberStore = inject(MemberStore)
    memberStore.getMemberWithCard()

    return of(true)
}